import "./user.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import excel from "../../components/excel/excel";
import { getUsers, updateUser } from "../../redux/apiCalls";
import moment from "moment";
import styled from "styled-components";
import Table from "../../components/advancedTable";
import Select from "react-select";

const statusOptions = [
    {
        label: "Inactive",
        value: "inactive",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "All",
        value: "",
    },
];

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;

    @media screen and (max-width: 768px) {
        position: fixed;
        z-index: 101;
        left: 60px;
        width: calc(100% - 60px);
        justify-content: center;
    }
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;

    @media screen and (max-width: 768px) {
        width: 90%;
        height: auto;
        max-height: 90vh;
        margin: 0 auto;
    }
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 120%;
    width: 100%;
    display: grid;

    @media screen and (max-width: 768px) {
        height: auto;
        max-height: 85vh;
        overflow-y: auto;
        display: block;
        padding: 1rem;
        box-sizing: border-box;
    }
`;

export default function User() {
    const dispatch = useDispatch();
    // eslint-disable-next-line
    const [inputs, setInputs] = useState({
        status: undefined,
        limit: 20,
        page: 1,
        name: undefined
    });
    const formatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [user, setUser] = useState(undefined);
    const [editModalState, setEditModalState] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );
    const marketing = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "marketing"
            : null
    );

    useEffect(() => {
        const fetchData = async () => {
            if (isLoaded === false) {
                try {
                    const result = await getUsers(dispatch, inputs);
                    setUsersData(result ? result.users : []);
                    setTotalPages(result.totalPages);
                    setIsLoaded(true);
                } catch (error) {
                    console.error("Error fetching users:", error);
                }
            }
        };

        fetchData();
    }, [dispatch, inputs, isLoaded]);

    const handleChange = (e) => {
        setUser((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleChangeAddress = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                address: { ...prev.address, [e.target.name]: e.target.value },
            };
        });
    };

    const handleNameChange = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, [e.target.name]: e.target.value };
        });
    };



    const handleInputStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, status: e.value };
        });
    };

    const handleClick = async () => {
        updateUser(user._id, user, dispatch);
    };

    const columns = [
        {
            accessor: "name",
            Header: "Name",
            width: 200,
            sortable: false,
        },
        {
            accessor: "phoneNumber",
            Header: "Phone Number",
            width: 200,
            sortable: false,
        },
        {
            accessor: "totalSpent",
            Header: "Total Spent",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">RM {formatter.format(value)}</div>
            ),
        },
        {
            accessor: "totalTransactions",
            Header: "Total Transactions",
            width: 200,
            sortable: false,
        },
        {
            accessor: "email",
            Header: "Email",
            width: 300,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">{value ? value : ""}</div>
            ),
        },
        {
            accessor: "ranking",
            Header: "Ranking",
            width: 150,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "status",
            Header: "Status",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "createdAt",
            Header: "Member Since",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "action",
            Header: "Action",
            width: 200,
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex justify-center">
                        <div
                            style={{
                                textDecoration: "none",
                                color: "black",
                            }}
                            to={"/warranty/" + params.row.original._id}
                        >
                            <button
                                onClick={() => {
                                    setUser(params.row.original);
                                    window.scrollTo(0, 0);
                                    setEditModalState(true);
                                }}
                                className="productListEdit warrantyWidth"
                            >
                                Edit
                            </button>
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className="user" style={{ backgroundColor: '#F8F8F8' }}>
                <div className="pageHeader" style={{ backgroundColor: '#FFFFFF', padding: '20px', margin: '0', borderRadius: '8px 8px 0 0' }}>
                    <h1 className="pageTitle" style={{ color: '#333333', fontSize: '2.5rem', fontWeight: 'bold', margin: '0 0 0.5rem 0' }}>User Management</h1>
                    <p className="pageDescription" style={{ color: '#666666', fontSize: '1rem', margin: '0', fontWeight: 'normal' }}>Manage system users and view customer information</p>
                </div>
                <div className="filters-container">
                    <div className="filters-row">
                        <div className="filter-item">
                            <input
                                className="filter-input"
                                name="name"
                                value={inputs.name}
                                type="string"
                                placeholder="Search by name"
                                onChange={handleNameChange}
                            />
                        </div>
                        <div className="filter-item">
                            <input
                                className="filter-input"
                                name="phoneNumber"
                                value={inputs.phoneNumber}
                                type="string"
                                placeholder="Search by phone"
                                onChange={handleNameChange}
                            />
                        </div>
                        <div className="filter-item">
                            <input
                                className="filter-input"
                                name="email"
                                value={inputs.email}
                                type="string"
                                placeholder="Search by email"
                                onChange={handleNameChange}
                            />
                        </div>
                        <div className="filter-item">
                            <Select
                                options={statusOptions.map((status, i) => {
                                    return {
                                        label: status.label,
                                        value: status.value,
                                    };
                                })}
                                onChange={handleInputStatus}
                                placeholder="Filter by status"
                                className="status-select"
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        width: '100%',
                                        padding: '0.25rem',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        fontSize: '0.875rem',
                                        transition: 'border-color 0.2s, box-shadow 0.2s',
                                        borderColor: state.isFocused ? '#014451' : '#d1d5db',
                                        boxShadow: state.isFocused ? '0 0 0 3px rgba(1, 68, 81, 0.1)' : 'none',
                                        '&:hover': {
                                            borderColor: state.isFocused ? '#014451' : '#d1d5db',
                                        },
                                        minHeight: '42px',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#6b7280',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: '#111827',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected ? '#014451' : state.isFocused ? '#f3f4f6' : 'white',
                                        color: state.isSelected ? 'white' : '#111827',
                                        '&:active': {
                                            backgroundColor: state.isSelected ? '#014451' : '#f3f4f6',
                                        },
                                    }),
                                }}
                            />
                        </div>
                        {(superadmin || marketing) && (
                            <div className="filter-item">
                                <button
                                    onClick={async() => {
                                        let payload = [];
                                        const exportData = await getUsers(dispatch, { ...inputs, limit: 9999 });

                                        exportData.users.forEach(
                                            (user, i) => {
                                                payload.push({
                                                    PhoneNumber: user.phoneNumber,
                                                    Email: user.email,
                                                });
                                            }
                                        );
                                        excel({
                                            excelData: payload,
                                            fileName: `Haofa-Users-Export`,
                                        });
                                    }}
                                    className="export-btn"
                                >
                                    Export Users
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                {isLoaded === true && (
                    <div className="user-container">
                        <Table
                            data={usersData}
                            columns={columns}
                            pageCount={Math.floor(totalPages / 20) + 2}
                            totalCount={totalPages}
                            updatePagination={setInputs}
                            paginationState={inputs}
                            updateLoaded={setIsLoaded}
                            hidePagination={inputs.limit === 20 ? false : true}
                        />
                    </div>
                )}
            </div>

            {editModalState && (
                <OverlayContainer>
                    <ModalContainer
                        onClick={() => setEditModalState(false)}
                    ></ModalContainer>
                    <Overlay onClick={(e) => {
                        // Only close on mobile when clicking outside the modal
                        if (window.innerWidth <= 768) {
                            setEditModalState(false);
                        }
                    }}>
                        <ModalDetails onClick={(e) => e.stopPropagation()}>
                            <ModalItemContainer className="ModalItemContainer">
                                <div className="updateTitle">
                                    <form className="addProductForm">
                                        <div className="addProductItem">
                                            <label className="black required">Full Name</label>
                                            <input
                                                name="name"
                                                type="text"
                                                defaultValue={user.name}
                                                placeholder="Name"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label className="black required">Email</label>
                                            <input
                                                name="email"
                                                type="text"
                                                defaultValue={user.email}
                                                placeholder="Email"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label className="black required">Phone Number</label>
                                            <input
                                                name="phoneNumber"
                                                type="text"
                                                defaultValue={user.phoneNumber}
                                                placeholder="Phone Number"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label className="black required">Password</label>
                                            <input
                                                name="password"
                                                type="password"
                                                placeholder="Password"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label className="black">Date of Birth (optional)</label>
                                            <input
                                                name="dob"
                                                type="date"
                                                value={
                                                    user.dob
                                                        ? moment(user.dob).format("YYYY-MM-DD")
                                                        : undefined
                                                }
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label className="black">Address (optional)</label>
                                            <input
                                                name="lineOne"
                                                type="string"
                                                defaultValue={
                                                    user.address && user.address.lineOne ? user.address.lineOne : ""
                                                }
                                                placeholder="Line One"
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="lineTwo"
                                                type="string"
                                                defaultValue={
                                                    user.address && user.address.lineTwo ? user.address.lineTwo : ""
                                                }
                                                placeholder="Line Two"
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="zip"
                                                type="string"
                                                defaultValue={
                                                    user.address && user.address.zip ? user.address.zip : ""
                                                }
                                                placeholder="Zipcode"
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="city"
                                                type="string"
                                                defaultValue={
                                                    user.address && user.address.city ? user.address.city : ""
                                                }
                                                placeholder="City"
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="country"
                                                type="string"
                                                defaultValue={
                                                    user.address && user.address.country ? user.address.country : ""
                                                }
                                                placeholder="Country"
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div
                                            onClick={handleClick}
                                            className="updateProductButton"
                                        >
                                            Update User
                                        </div>
                                    </form>
                                </div>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
        </>
    );
}
